<tui-root>
    <router-outlet />

    <ng-container ngProjectAs="tuiOverContent" />
    <ng-container ngProjectAs="tuiOverDialogs" />
    <ng-container ngProjectAs="tuiOverAlerts" />
    <ng-container ngProjectAs="tuiOverPortals" />
    <ng-container ngProjectAs="tuiOverHints" />
</tui-root>
